// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__2Z19e","Menu":"SiderContentC_Menu__+OlHb"};